import Vue from 'vue';
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
  {
    path: '/search/:refNo?',
    name: 'Search',
    component: () => import('../views/Search.vue'),
  },
];

const router = new VueRouter({
  // base: process.env.BASE_URL,
  routes,
});

const redirect = (params) => {
  router.push({ name: 'Search', params })
}

// eslint-disable-line
router.beforeEach(async (to, from, next) => {
  const path = decodeURIComponent(to.fullPath)
  if (path.search('/search') >= 0) return next()
  redirect(to.params)
})

export default router;
